import { Controller } from "stimulus"

// One status select per waitlist row. Declined and On waitlist post the state to the
// reservation; Reserved goes through the promote action instead, which is what checks the
// seat (and asks about overcapacity) - a plain state write would skip that.
export default class extends Controller {
  static targets = ["select", "stateForm", "promoteForm"]

  change() {
    if (this.selectTarget.value === "reserved" && this.hasPromoteFormTarget) {
      this.promoteFormTarget.requestSubmit()
    } else {
      this.stateFormTarget.requestSubmit()
    }
  }
}
